import React from 'react';
import PropTypes from 'prop-types';
import {
  CheckList,
  Checkbox,
  CheckboxItem,
  CheckboxContent,
  Checkmark,
} from '../styles';

const { object, array, number, string } = PropTypes;

const RadioQuestion = (props) => {
  const {
    answerOptions,
    color,
    field,
    fieldName,
    form,
    bookingId,
    experienceQuestionId,
    guestId,
  } = props;

  const handleToggle = (value) => {
    const oldValue = field.value;
    const newQuestionOptionId =
      value !== oldValue?.questionOptionId ? value : null;
    form.setFieldValue(fieldName, {
      questionOptionId: newQuestionOptionId,
      id: oldValue?.id,
      experienceQuestionId,
      bookingId,
      guestId,
    });
  };
  const value = field.value || {};
  const { questionOptionId } = value;
  return (
    <CheckList>
      {answerOptions.map((option) => (
        <CheckboxItem
          key={option.value}
          onClick={() => handleToggle(option.value)}
        >
          <Checkbox
            circle
            active={questionOptionId === option.value}
            color={color}
          >
            {questionOptionId === option.value && (
              <Checkmark>
                <i className="icon af-checkmark" />
              </Checkmark>
            )}
          </Checkbox>
          <CheckboxContent>{option.label}</CheckboxContent>
        </CheckboxItem>
      ))}
    </CheckList>
  );
};

RadioQuestion.propTypes = {
  value: object,
  answerOptions: array.isRequired,
  color: string,
  fieldName: string.isRequired,
  form: object.isRequired,
  bookingId: number.isRequired,
  experienceQuestionId: number.isRequired,
};

export default RadioQuestion;
